import React from "react";
import { createPortal } from "react-dom";
import Button from "../../components/staff/Button";

type DiscardPaymentRegistrationModalProps = {
  isOpen: boolean;
  invoiceNumber?: string;
  onGoBack: () => void;
  onConfirmExit: () => void;
};

export default function DiscardPaymentRegistrationModal({
  isOpen,
  invoiceNumber,
  onGoBack,
  onConfirmExit,
}: DiscardPaymentRegistrationModalProps): React.ReactElement | null {
  if (!isOpen) {
    return null;
  }

  const invoiceRef = invoiceNumber?.trim();
  const message = invoiceRef
    ? `ARE YOU SURE YOU WANT TO CANCEL THE PROCESS WITHOUT SAVING CHANGES? NO PAYMENTS WILL BE CHARGED TO THIS INVOICE ${invoiceRef}`
    : "ARE YOU SURE YOU WANT TO CANCEL THE PROCESS WITHOUT SAVING CHANGES? NO PAYMENTS WILL BE CHARGED.";

  return createPortal(
    <div className="fixed inset-0 z-[2000] overflow-y-auto">
      <div
        className="fixed inset-0 bg-black bg-opacity-80"
        onClick={onGoBack}
      />

      <div className="flex min-h-full items-center justify-center p-4">
        <div
          className="relative w-full max-w-lg rounded-lg bg-white p-6 shadow-xl"
          onClick={(e) => e.stopPropagation()}
        >
          <h2 className="mb-4 font-decimal text-xl font-medium text-Default">
            Cancel Payment Registration
          </h2>

          <p className="mb-6 text-sm font-medium uppercase leading-relaxed text-gray-font">
            {message}
          </p>

          <div className="flex flex-wrap justify-end gap-3">
            <Button
              text="Go Back"
              color="secondary"
              variant="outlined"
              size="fixed"
              onClick={onGoBack}
            />
            <Button
              text="Confirm Exit"
              color="secondary"
              variant="filled"
              size="fixed"
              onClick={onConfirmExit}
            />
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
